import {Injectable} from '@angular/core';
import {Socket} from 'ngx-socket-io';
import {ConfigurationService} from '../../core/services/configuration.service';
import {Subscription} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class GoldfingerSocketService {
    private sockets: { [sessionId: string]: Socket; };
    private listeners: { [sessionId: string]: { [eventName: string]: (data: any) => void } };

    constructor(private configurationService: ConfigurationService) {
        this.sockets = {};
        this.listeners = {};
    }

    listen(sessionId: string) {
        const wsUrl: string = (<any>window).external_configuration.goldfingerWebsocket;

        this.sockets[sessionId] = new Socket({
            url: wsUrl,
            options: {
                query: {
                    sessionId: sessionId
                }
            }
        });

        this.sockets[sessionId].on('connect', (data) => {
            this.sockets[sessionId].emit('msg', {
                type: 'hello',
                id: sessionId
            }, responseData => console.log(responseData));
        });

        this.sockets[sessionId].on('msg', (data) => {

            if (typeof data === 'object' && data.hasOwnProperty('type')) {
                if (typeof this.listeners[sessionId][data.type] !== 'undefined') {
                    this.listeners[sessionId][data.type](data);
                }
            }
        });
    }

    on(sessionId: string, eventName: string, callback: (data: any) => void) {
        if (typeof this.listeners[sessionId] === 'undefined') {
            this.listeners[sessionId] = {};
        }
        this.listeners[sessionId][eventName] = callback;
    }

    close(sessionId) {
        if (this.sockets.hasOwnProperty(sessionId)) {
            let socket = this.sockets[sessionId];
            socket.removeAllListeners('connect');
            socket.removeAllListeners('msg');
            socket.disconnect(true);
            this.sockets[sessionId] = null;
        }
    }
}
